export class Client {
    class: string;
    id: number;
    name: string;
    constructor(data) {
        
        this.class = data.class;
        this.id = data.id;
        this.name = data.name;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/app/class/client.ts